import { request as sonataRequest } from 'sonata-react-components';
import { UserEntity } from 'sonata-static-storage/lib/entities/user/user.entity';

import { SignupFormValues } from '@/validators/user.validator';

import type { SessionInterface } from 'sonata-static-storage/lib/schemas/session/session.schema';

export function loginUser(email: string, password: string): Promise<SessionInterface> {
  return sonataRequest.makeUnauthorizedRequest(`${taptap.config.backendUrlBase}session`, {
    data: {
      email,
      password,
      sessionId: '',
      user: ''
    },
    method: 'POST'
  });
}

export function signUpUser(signUpForm: SignupFormValues): Promise<any> {
  const userData = new UserEntity({
    acceptedTerms: signUpForm.acceptedTerms as any,
    companyName: signUpForm.companyName,
    country: signUpForm.country,
    email: signUpForm.email,
    password: signUpForm.password,
    userVersion: 2
  }).toJSON();
  return sonataRequest.makeUnauthorizedRequest(`${taptap.config.backendUrlBase}user`, {
    data: userData,
    method: 'POST'
  });
}

export function sendPasswordResetEmail(email: string): Promise<any> {
  return sonataRequest.makeUnauthorizedRequest(`${taptap.config.backendUrlBase}user/password/${email}`, {
    method: 'POST',
    params: {
      v2: true
    }
  });
}

export function changePassword(email: string, token: string, password: string): Promise<any> {
  return sonataRequest.makeUnauthorizedRequest(
    `${taptap.config.backendUrlBase}user/password/${email}/${token}/${password}`,
    {
      data: {
        email,
        password,
        token
      },
      method: 'POST'
    }
  );
}
